import "../css/tailwind.css";

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

import "./blocks/index.js"
import "./donorfy/index.js"

import nav from './nav.js';

window.nav = nav;
window.Alpine = Alpine;
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();
